<template>
  <div>
    <div class="google-translate-btn" :class="{ ready: isReady }">
      <button accesskey="T" @click.prevent="handleClick">Translate</button>
    </div>
  </div>
</template>

<script>
/* global google */
export default {
  name: 'GoogleTranslateBtn',

  data: () => ({
    isReady: false,
    show: false,
    modalElement: null
  }),

  mounted () {
    // Load Google Translate script
    const script = document.createElement('script')
    script.onload = () => {
      this.isReady = true
    }
    script.async = true
    script.src =
      '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
    document.head.appendChild(script)

    // Create the modal element and append to body
    this.modalElement = document.createElement('div')
    this.modalElement.classList.add('g-modal')
    this.modalElement.id = 'google_translate_modal'
    this.modalElement.style.display = 'none' // Hide initially
    this.modalElement.innerHTML = `
      <div class="g-modal-content">
        <span class="close-btn">&times;</span>
        <h2 class="translate__heading">Translate</h2>
        <p class="translate__intro">
          Use Google to translate the web site. We take no responsibility for the accuracy of the translation.
        </p>
        <div id="google_translate_element"></div>
      </div>
    `
    document.body.appendChild(this.modalElement)

    // Add close functionality
    const closeButton = this.modalElement.querySelector('.close-btn')
    closeButton.addEventListener('click', this.closeModal)

    // Stop event propagation for modal content to prevent closing when clicking inside the modal
    this.modalElement.querySelector('.g-modal-content').addEventListener('click', (e) => {
      e.stopPropagation()
    })

    // Detect outside clicks to close the modal
    document.addEventListener('click', this.handleOutsideClick)

    // Detect Esc key to close the modal
    document.addEventListener('keydown', this.handleEscKey)

    window.googleTranslateElementInit = () => {
      // eslint-disable-next-line no-new
      new google.translate.TranslateElement(
        { pageLanguage: 'sv' },
        'google_translate_element'
      )

      // Use MutationObserver to detect changes in the `lang` attribute of the html tag
      var targetNode = document.documentElement // The <html> tag

      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (
            mutation.type === 'attributes' &&
        mutation.attributeName === 'lang'
          ) {
            this.closeModal() // Correctly refer to `this`
          }
        }
      })

      observer.observe(targetNode, {
        attributes: true // Monitor attribute changes
      })
    }
  },

  methods: {
    handleClick (event) {
      // Prevent button click from registering as outside click
      event.stopPropagation()
      this.show = !this.show
      this.modalElement.style.display = this.show ? 'block' : 'none'
      if (this.show) {
        // Focus on the close button
        this.modalElement.querySelector('select').focus()
      }
    },

    closeModal () {
      this.show = false
      this.modalElement.style.display = 'none'
    },

    handleOutsideClick (event) {
      if (this.show && this.modalElement) {
        this.closeModal() // Hide the modal if clicked outside
      }
    },

    handleEscKey (event) {
      if (event.key === 'Escape' && this.show) {
        this.closeModal() // Hide the modal if Esc key is pressed
      }
    }
  },

  beforeUnmount () {
    // Clean up event listener
    document.removeEventListener('click', this.handleOutsideClick)
    document.removeEventListener('keydown', this.handleEscKey)
  }
}
</script>
